import * as React from "react";
import type { SVGProps } from "react";
const SvgBed2Persons = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#362F2F"
      d="M22 10.18V4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v6.18c-1.16.41-2 1.51-2 2.82v7c0 .55.45 1 1 1s1-.45 1-1v-2h20v2c0 .55.45 1 1 1s1-.45 1-1v-7c0-1.3-.84-2.4-2-2.82M10 10H6V9c0-.55.45-1 1-1h2c.55 0 1 .45 1 1zm8 0h-4V9c0-.55.45-1 1-1h2c.55 0 1 .45 1 1zM4 5h16v4c0-1.65-1.35-3-3-3h-2c-1.65 0-3 1.35-3 3 0-1.65-1.35-3-3-3H7C5.35 6 4 7.35 4 9zm-2 8c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v3H2z"
    />
  </svg>
);
export default SvgBed2Persons;
